  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <app-loadconfirm *ngIf="showSpinner" [text]="'orgsettings.settingsloader' | trans " [icon]="'refresh'"></app-loadconfirm>
      <div class="modal-header">
        <h5 class="modal-title">{{ 'orgsettings.title' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
       <form>
        <div class="form-group">
            <label for="LanguageSelect"><p class="mb-0">{{ 'orgsettings.systemlanguage' | trans }}</p></label>
            <select class="form-control" id="LanguageSelect" name="orglanguage" [(ngModel)]="orgsettings.orglanguage">
                <option value="EN">{{ 'orgsettings.english' | trans }}</option>
                <option value="DA">{{ 'orgsettings.danish' | trans }}</option>
                <option value="SE">{{ 'orgsettings.swedish' | trans }}</option>
                <option value="NO">{{ 'orgsettings.norwegian' | trans }}</option>
                <option value="FI">{{ 'orgsettings.finnish' | trans }}</option>
            </select>
          </div>
       </form>
       <div *ngIf="updated" class="alert alert-success" role="alert">
        {{ 'orgsettings.updated' | trans }}
      </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'orgsettings.close' | trans }}</p></button>
        <button type="button" class="btn-save" (click)="updateOrgSettings()"><p class="btn-save-text">{{ 'orgsettings.savechanges' | trans }}</p></button>
      </div>
    </div>
  </div>
